import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';
import { UpdateCompanyLogoRequest } from '../models/companies';

@Injectable({
  providedIn: 'root'
})
export class CompanyDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getCompanyOptionsAsync(query: string, cancellationToken: Promise<any> = null): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('Companies/Options', request, cancellationToken);
  }

  public updateCompanyLogoAsync(request: UpdateCompanyLogoRequest): Promise<any> {
    return this.httpClient.postJsonAsync('CompanyWidget/UpdateCompanyLogo', request);
  }
}
